import React, { ReactElement } from 'react';
// import { useInView } from 'react-intersection-observer';

import Footer from '../components/footer/Footer';
import NavBar from '../components/navbar/NavBar';
import { RegionProvider } from '../region/RegionProvider';
import CookieNotification from '../components/cookieNotification/CookieNotification';
import GeolocationPopup from '../components/geolocation/GeolocationPopup';
import { useLocation } from '@reach/router';

type BodyPropsType = {
  children: ReactElement | null;
};

const ADS_PATH_PREFIXES = [
  '/ads',
  '/adsAEM',
  '/adsAnalytics',
  '/adsCommerce',
  '/adsAI',
  '/adsEnterprise',
  '/adsPartner',
  '/adsEdge',
  '/adsWorkfront',
  '/adsAssets',
  '/adsGenStudio',
  '/adsAEM2',
  '/adsAnalytics2',
  '/adsCommerce2',
  '/adsAI2',
  '/adsEnterprise2',
  '/adsPartner2',
  '/adsEdge2',
  '/adsWorkfront2',
  '/adsAssets2',
  '/adsGenStudio2',
  '/thank-you',
];

const Layout = ({ children = null }: BodyPropsType) => {
  const location = useLocation();
  const pathname = location?.pathname ?? '';

  const isAdsPath = ADS_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

  const shouldRenderLayoutUi = !isAdsPath;
  return (
    <RegionProvider>
      <div
        data-testid="layout-container"
        className="flex flex-col min-h-screen"
      >
        {shouldRenderLayoutUi && (
          <>
            <GeolocationPopup />
            <NavBar />
            <CookieNotification />
          </>
        )}

        <main className="flex-grow mb-[20px] sm:mb-[60px] lg:mb-[100px]">
          {children}
        </main>

        {shouldRenderLayoutUi && <Footer />}
      </div>
    </RegionProvider>
  );
};

export default Layout;
